// Reducer
const searchRefState = {
    searchTitle: '',
    searchDateFrom: '',
    searchDateTo: '',
    searchCreateDateFrom: '',
    searchCreateDateTill: '',
    searchCountry: '',
    searchProvince: '',
    searchCity: '',
    searchProductSystem: '',
    searchProduct: '',
    searchZip: '',
    searchFOE: '',
    referencesData: '',
    searchContestRelease: 'false',
    searchCreator:'',
    searchFirm:'',
    selectAllButton: false

}

export default function searchRefInfo(state = searchRefState, action) {
    switch (action.type) {
        case 'SET_SEARCH_TITLE':
            return { ...state, searchTitle: action.payload }
        case 'SET_SEARCH_DATE_FROM':
            return { ...state, searchDateFrom: action.payload }
        case 'SET_SEARCH_DATE_TO':
            return { ...state, searchDateTo: action.payload }
        case 'SET_SEARCH_CREATE_DATE_FROM':
            return { ...state, searchCreateDateFrom: action.payload }
        case 'SET_SEARCH_CREATE_DATE_TILL':
            return { ...state, searchCreateDateTill: action.payload }
        case 'SET_SEARCH_COUNTRY':
            return { ...state, searchCountry: action.payload }
        case 'SET_SEARCH_PROVINCE':
            return { ...state, searchProvince: action.payload }
        case 'SET_SEARCH_CITY':
            return { ...state, searchCity: action.payload }
        case 'SET_SEARCH_PRODUCT_SYSTEM':
            return { ...state, searchProductSystem: action.payload }
        case 'SET_SEARCH_PRODUCT':
            return { ...state, searchProduct: action.payload }
        case 'SET_SEARCH_ZIP':
            return { ...state, searchZip: action.payload }
        case 'SET_SEARCH_FOE':
                return { ...state, searchFOE: action.payload }
        case 'SET_SEARCH_REFERENCES_DATA':
            return { ...state, referencesData: action.payload }
        case 'SET_SEARCH_CONTEST_RELESE':
            return { ...state, searchContestRelease: action.payload }
        case 'SET_SEARCH_CREATOR':
                return { ...state, searchCreator: action.payload }
        case 'SET_SEARCH_FIRM':
                return { ...state, searchFirm: action.payload }
        case 'SET_SELECT_ALL':
                return { ...state, selectAllButton: action.payload }
        default:
            return state;

    }
}